import { gql } from '@apollo/client';
 

export const NOTIFY_SCORM_COURSE = gql`
  mutation notifyScormCourse( $input: NotifyScormCourseInput! ){
    result: notifyScormCourse(input: $input) {
        status
    }
  }
`;
